import { createSlice, type PayloadAction } from "@reduxjs/toolkit/react";
import {
  PlaybookContentIntegrationType,
  PlaybookContentPlanType,
  type PlaybookContentGuide,
} from "./api.types";
import { loadPlaybook } from "./persist";

export type PlaybookState = {
  planFilter: PlaybookContentPlanType | null;
  integrationFilter: PlaybookContentIntegrationType;
  viewedGuides: Record<string, number>;
};

const initialState: PlaybookState = {
  planFilter: null,
  integrationFilter: PlaybookContentIntegrationType.All,
  ...loadPlaybook(),
};

export const playbook = createSlice({
  name: "playbook",
  initialState,
  reducers: {
    setPlanFilter: (
      state,
      action: PayloadAction<PlaybookContentPlanType | null>,
    ) => {
      state.planFilter = action.payload;
    },
    setIntegrationFilter: (
      state,
      action: PayloadAction<PlaybookContentIntegrationType>,
    ) => {
      state.integrationFilter = action.payload;
    },
    markGuideViewed: (
      state,
      action: PayloadAction<
        Pick<PlaybookContentGuide, "short_id" | "published_at">
      >,
    ) => {
      const { short_id, published_at } = action.payload;
      const publishedAt = published_at ? new Date(published_at).getTime() : 0;
      const time = Math.max(Date.now(), publishedAt);
      state.viewedGuides[short_id] = time;
    },
  },
});
